import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { MessageCircle, Loader2 } from "lucide-react";
import { ReservationSuccessAnimation } from "@/components/ReservationSuccessAnimation";
import { useChateaux } from "@/hooks/useChateaux";
import { useReservationForm } from "@/hooks/useReservationForm";
import { ProductSelector } from "@/components/form/ProductSelector";
import { FormFields } from "@/components/form/FormFields";

interface ReservationFormProps {
  preSelectedChateau?: string;
}

export const ReservationForm = ({ preSelectedChateau }: ReservationFormProps) => {
  const { chateaux } = useChateaux();
  
  const {
    form,
    isLoading,
    showSuccess,
    showChateauType,
    handleProductChange,
    onSubmit,
    chateauOptions
  } = useReservationForm({
    preSelectedChateau,
    chateaux
  });

  if (showSuccess) {
    return <ReservationSuccessAnimation />;
  }

  return (
    <Card className="shadow-card border-0">
      <CardHeader>
        <CardTitle className="text-2xl font-display">Demande de Réservation</CardTitle>
        <p className="text-muted-foreground">
          Remplissez ce formulaire et nous vous recontactons rapidement pour finaliser votre réservation.
        </p>
      </CardHeader>
      <CardContent className="space-y-6">
        <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6">
          <FormFields form={form} />
          
          <ProductSelector
            form={form}
            showChateauType={showChateauType}
            onProductChange={handleProductChange}
            chateauOptions={chateauOptions}
          />

          <div className="flex justify-center">
            <Button 
              type="submit" 
              variant="hero" 
              size="lg" 
              className="w-full max-w-md"
              disabled={isLoading}
            >
              {isLoading ? (
                <Loader2 className="w-4 h-4 mr-2 animate-spin" />
              ) : (
                <MessageCircle className="w-4 h-4 mr-2" />
              )}
              {isLoading ? "Envoi en cours..." : "Envoyer ma Demande de Réservation"}
            </Button>
          </div>
        </form>
      </CardContent>
    </Card>
  );
};